import React from 'react';

import VerificationRequest from 'components/VerificationRequest';
import TechnicianConfirmation from 'components/VerificationRequest/TechnicianConfirmation';

interface IProps {
  children: React.ReactNode;
}

const VerificationRequestProvider: React.FC<IProps> = ({ children }) => {
  return (
    <>
      {children}
      <VerificationRequest />
      <TechnicianConfirmation />
    </>
  );
};

export default VerificationRequestProvider;
